import { useRef } from 'react';
import { Input, Select, DatePicker } from 'antd';
import XTable from 'components/XTable';
import { getCheckInRecordListApi, getDownloadCheckApi } from 'api/checkInRecord';
import { getFilterText, downFile } from 'utils';
import { nursingAreas } from 'enumeration/nursingAreas';
import { sexTypes } from 'enumeration/sexTypes';
import { identityType } from 'enumeration/identityType';
import moment from 'moment';
const { Option } = Select;
const { RangePicker } = DatePicker;

const CheckOutRecord = () => {
    const xTableRef = useRef();

    const columns = [
        {
            title: '姓名',
            dataIndex: 'name',
        },
        {
            title: '身份证号',
            dataIndex: 'idNo',
        },
        {
            title: '年龄',
            dataIndex: 'age',
        },
        {
            title: '性别',
            dataIndex: 'sex',
            render: val => getFilterText(sexTypes, val),
        },
        {
            title: '申请区域',
            dataIndex: 'nursingArea',
            render: val => getFilterText(nursingAreas, val),
        },
        {
            title: '身份类型',
            dataIndex: 'identityType',
            render: val => getFilterText(identityType, val),
        },
        {
            title: '入住时间',
            dataIndex: 'createAt',
            render: val => (val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
        {
            title: '出院时间',
            dataIndex: 'updateAt',
            render: val => (val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
    ];

    const queryItems = [
        {
            formItemApis: {
                label: '申请日期',
                help: null,
                name: 'createDate',
            },
            item: <RangePicker format="YYYY-MM-DD" />,
        },
        {
            formItemApis: {
                label: '身份证号',
                help: null,
                name: 'idNo',
            },
            item: <Input style={{ width: 200 }} allowClear />,
        },
        {
            formItemApis: {
                label: '姓名',
                help: null,
                name: 'name',
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
        {
            formItemApis: {
                label: '申请区域',
                help: null,
                name: 'value',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {nursingAreas.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
    ];
    const handelParams = params => {
        const { createDate, ...otherParams } = params;
        let beginDate = '';
        let endDate = '';
        let newParams = otherParams;
        if (createDate && createDate.length) {
            beginDate = moment(createDate[0]).format('YYYY-MM-DD');
            endDate = moment(createDate[1]).format('YYYY-MM-DD');
            newParams = { ...otherParams, beginDate, endDate };
        }
        return newParams;
    };
    const downloadRecord = () => {
        const queryValue = xTableRef.current.queryForm?.getFieldsValue();
        const params = handelParams(queryValue);
        params.status = false;
        getDownloadCheckApi(params).then(res => {
            if (res.success) {
                const filename = `出院记录${moment().valueOf()}.xls`;
                downFile(res.file, filename);
            }
        });
    };
    const actionBtns = [{ text: '导出记录', onClick: downloadRecord }];

    return (
        <div>
            <XTable
                columns={columns}
                queryItems={queryItems}
                actionBtns={actionBtns}
                handelParams={handelParams}
                api={getCheckInRecordListApi}
                rowKey="id"
                ref={xTableRef}
                apiParams={{ status: false }}
            />
        </div>
    );
};
export default CheckOutRecord;
